import { injectable } from 'inversify'

import { StoreBase } from '@writefull/core'

import { Notification } from '@domain/notification'

export interface NotificationsStoreState {
  notifications: Notification[]
}

export interface NotificationsStoreActions {
  show: (notification: Notification) => void
  hide: (id: number) => void
}

const initialState: NotificationsStoreState = {
  notifications: [],
}

const actions = (
  set: (fn: (state: NotificationsStoreState) => NotificationsStoreState) => void,
): NotificationsStoreActions => ({
  show: (notification: Notification) =>
    set((s) => ({
      ...s,
      notifications: [...s.notifications, notification],
    })),
  hide: (id: number) =>
    set((s) => ({ ...s, notifications: s.notifications.filter((n) => n.id !== id) })),
})

@injectable()
export class NotificationsStore extends StoreBase<
  NotificationsStoreState,
  NotificationsStoreActions
> {
  constructor() {
    super(initialState, actions)
  }
}

export const notificationsStore = new NotificationsStore()
const useNotificationsStore = notificationsStore.getStore()
export default useNotificationsStore
